import PropTypes from 'prop-types';
import { capabilityGroup } from '../proptypes/index';

const Capabilities = ({ appName, group }) => {
  const { capabilities, description } = group;

  return capabilities.length === 1 && !description ? (
    <div key={`integration-capability-${capabilities[0].name}`}>
      {capabilities[0].name.replace(/APPNAME/g, appName)}
    </div>
  ) : (
    <ul>
      {capabilities.map(capability => (
        <li key={`integration-capability-${capability.name}`}>
          {capability.name.replace(/APPNAME/g, appName)}
        </li>
      ))}
    </ul>
  );
};

Capabilities.propTypes = {
  appName: PropTypes.string.isRequired,
  group: capabilityGroup.isRequired,
};

const renderCapabilityGroup = (appName, group) => {
  return (
    <div key={`integration-capability-group-${group.name}`} className="capabilityGroup">
      <div>
        <strong>{group.name.replace(/APPNAME/g, appName)}</strong>
        {!!group.description && (
          <div className="description">{group.description.replace(/APPNAME/g, appName)}</div>
        )}
        <Capabilities appName={appName} group={group} />
      </div>
    </div>
  );
};

const CapabilitiesSection = ({ appName, capabilityGroups }) => {
  return (
    <div className="capabilities">
      <h4>App capabilities</h4>
      {capabilityGroups.map(group => renderCapabilityGroup(appName, group))}
    </div>
  );
};

CapabilitiesSection.propTypes = {
  capabilityGroups: PropTypes.arrayOf(capabilityGroup).isRequired,
  appName: PropTypes.string.isRequired,
};

export default CapabilitiesSection;
